export default __webpack_public_path__ + "img/bcec5b23cd5e8ea1b37ac077feedd90e.svg";